module.exports = "/images/clubspeed.png?230fd75e6ed8d7d974735bc170654a94";